var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 841.9",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.9,516.3c-4-8.1-8.4-15.9-12.7-23.8c-38.8-71.6-77.7-143.2-116.4-214.8c-5.8-10.8-14.5-17.2-26.7-17.1 c-12.2,0.1-21.3,6.2-27.2,17.2c-22.7,42.1-45.5,84.1-68.3,126.1c-19.7,36.3-39.5,72.6-59,109c-2.7,5-5,10.8-5.3,16.4 c-1.1,16.6,13.1,30.5,30.1,30.5c43,0,216.3,0.5,260,0.1C432.6,559.6,445.9,536.4,435.9,516.3z M280.6,512.7c-0.3,0-0.6,0-0.8,0 c-0.3,0-0.5,0-0.8,0c-11-0.2-19.7-9.3-19.6-20.5c0.2-10.7,7.6-18.9,17.6-20.3v-0.1c0.8-0.1,1.5-0.1,2.3-0.1c0.1,0,0.3,0,0.4,0 c0.1,0,0.3,0,0.4,0c0.8,0,1.6,0,2.3,0.1v0.1c10.1,1.4,17.5,9.6,17.6,20.3C300.3,503.4,291.6,512.6,280.6,512.7z M300.1,354.7 c-0.7,27.1-1.5,54.3-2.1,81.4c-0.2,10.4-7.2,17-18.2,16.4c-11,0.6-18-6.1-18.2-16.4c-0.6-27.1-1.4-54.3-2.1-81.4 c-0.1-2.2-0.2-4.4,0.2-6.5c1-5.7,4.8-9,10.9-9.1c3.1,0,6.2,0,9.3,0c3.1,0,6.2-0.1,9.3,0c6.1,0.1,9.9,3.4,10.9,9.1 C300.3,350.3,300.2,352.5,300.1,354.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.d59d118b2ab3db44d16450e87c7d96e3.svg";
export { ForwardRef as ReactComponent };